import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const StackoverflowScaleMedium = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M18.7169 20.3724V16.6908L21.5999 16.5996V22.5996L2.3999 22.5996L2.3999 16.5996H5.34784V20.2812L18.7169 20.3724Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.8515 1L14.2149 2.21297L20.2864 10.3879L21.923 9.17784L15.8515 1ZM18.6235 12.3392L10.7839 5.82577H10.7853L12.0785 4.26953L19.9168 10.783L18.6235 12.3392ZM8.22369 10.3619L17.4618 14.6599L18.3064 12.8138L9.06831 8.48975L8.22369 10.3619ZM6.90424 15.1088L16.8817 17.1915L17.3041 15.1867L7.32654 13.104L6.90424 15.1088ZM16.3847 19.7495H6.69238V17.7188H16.3847V19.7495Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Stackoverflow'
);
export default StackoverflowScaleMedium;
